// extracted by mini-css-extract-plugin
export default {"home":"index_home__fyQMV","content":"index_content__B-Yyq","top":"index_top__KIBlp","table":"index_table__8+DWh"};